"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.County = void 0;
const index_1 = require("../index");
const IdentityInfo_1 = __importDefault(require("../IdentityInfo"));
class County {
    //   County Name
    // Commuters
    // Public Transit Commuters
    // Median Household Income
    // Households with No Vehicle Available
    // Traffic Volume Score
    // (remove Transit percent)
    constructor(type, data) {
        this.identityInfo = IdentityInfo_1.default.genFromList(type, data, [
            "OBJECTID",
            "Abbrev",
            null,
            "CD_ID",
            "SLDU_ID",
            "SLDL_ID",
        ]);
        //@ts-ignore
        this.GEO_ID_1 = index_1.parseEsriString(data?.GEOID_1);
        this.STATEFP10 = index_1.parseEsriString(data?.STATEFP10);
        this.NAME10 = index_1.parseEsriString(data?.NAME);
        //@ts-ignore
        this.NAMELSAD10 = index_1.parseEsriString(data?.NAMELSAD);
        this.NAME = index_1.parseEsriString(data?.NAME);
        this.pop = index_1.parseEsriNumber(data?.pop);
        this.pop_commuting = index_1.parseEsriNumber(data?.pop_commuting);
        this.pop_car = index_1.parseEsriNumber(data?.pop_car);
        this.pop_carpool = index_1.parseEsriNumber(data?.pop_carpool);
        this.pop_public_trans = index_1.parseEsriNumber(data?.pop_public_trans);
        this.pop_walk = index_1.parseEsriNumber(data?.pop_walk);
        this.pop_other = index_1.parseEsriNumber(data?.pop_other);
        this.Shape_Length = index_1.parseEsriNumber(data?.Shape_Length);
        this.Shape_Area = index_1.parseEsriNumber(data?.Shape_Area);
        this.pct_transit = index_1.parseEsriNumber(data?.pct_transit);
        this.commute = index_1.parseEsriNumber(data?.commute);
        this.no_vehicle_households = index_1.parseEsriNumber(data?.no_vehicle_households);
        this.med_income = index_1.parseEsriNumber(data?.med_income);
        this.traffic_vol_score = index_1.parseEsriString(data?.traffic_vol_score);
    }
}
exports.County = County;
